export const EMOJI_RATINGS = [
  { emoji: '😠', value: 1 },
  { emoji: '🙁', value: 2 },
  { emoji: '😐', value: 3 },
  { emoji: '😊', value: 4 },
  { emoji: '😍', value: 5 }
]
